<template>
  <div class="card cusiplisting" id="scroll">
    <div class="cursor-pointer">
      <h3
        class="text-left accordion-button m-3"
        v-b-toggle="'accordion-cusipDetail'"
        variant="info"
      >
        CUSIP {{ cusipName }}
      </h3>
      <div class="position-absolute right-5 top-3 text-dark">
        <button 
          :disabled="cusipBidStatusLoader"  
          class="btn btn-sm rounded"
          v-bind:class="[isNoBidCusip ? 'btn-danger' : 'btn-success']" 
          @click="markAsDoNotBid()">
        <span v-if="cusipBidStatusLoader">
            <i class="fa fa-spinner fa-spin"></i>  
          </span>
          {{isNoBidCusip ? "Remove from Do Not Bid List" :  "Add to Do Not Bid List"}}
        </button>
        <button v-if="!idcPrice" class="btn btn-sm btn-warning rounded" @click="getIdcPrice()">
          <span v-if="idcApiRunning">
            <i class="fa fa-spinner fa-spin"></i>  
          </span>
          Get IDC price
        </button>
        <h3 v-if="idcPrice" class="text-dark-red">
          IDC PRICE : {{idcPrice | currency }}
        </h3>
      </div>
      
    </div>
    <div class="cusip-details">
      <div v-if="offerInEcn" class="text-left text-success">
        <div v-for="offer in offerInEcnArray"  :key="offer.message" >
          <span >{{offer.message}} with price  {{ offer.price | currency }}</span> and quantity  {{ offer.quantity }}.<br>
        </div>
        <!-- <div style="display: grid;">
          <span>ECN SENT Offer Exist</span>
          <span class="text-warning">Price : {{ offerInEcn.price }}</span>
          <span class="text-warning">Quantity : {{ offerInEcn.quantity }}</span>
          <span class="text-warning">Source : {{offerInEcn.createSource.toString().toLocaleUpperCase().replace("_", " ")}}</span>
        </div> -->
      </div>
      <h4 v-if="!offerInEcn" class="text-left text-warning">
        ECN SENT Offer Doesn't Exist
      </h4>
      <div class="cusip-parent">
          <div
            class="cusip-child"
            v-for="(value, key) in defaultDetails"
            :key="key"
          >
            <h5>{{ convertToWord(key) }}</h5>
            <span>{{ value ? value : "N/A" }}</span>
          </div>
        </div>
      </div>
    <b-collapse
      :id="'accordion-cusipDetail'"
      accordion="my-accordion-parent"
      role="tabpanel"
    >
      <div class="cusip-details">
        <div v-if="loading" class="loader">
          <img src="@/assets/img/loader.svg" alt="" />
        </div>
        <div class="cusip-parent">
          <div
            class="cusip-child"
            v-for="(value, key) in cusipObj"
            :key="key"
          >
            <h5>{{ convertToWord(key) }}</h5>
            <span>{{ value ? value : "N/A" }}</span>
          </div>
        </div>
        <div>
          <hr />
          <h3 class="text-left">Reference Data</h3>
          <div class="cusip-parent">
            <div
              class="cusip-child"
              v-for="(value, key) in referenceData"
              :key="key"
            >
              <h5>{{ convertToWord(key) }}</h5>
              <span>{{ value ? value : "N/A" }}</span>
            </div>
          </div>
        </div>
        <div>
          <hr />
          <div class="cursor-pointer">
            <h3
              class="text-left accordion-button"
              v-b-toggle="'accordion-cusip'"
              variant="info"
            >
              Call Schedules
            </h3>
          </div>
          <b-collapse
            :id="'accordion-cusip'"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="table-responsive">
              <table
                class="table align-items-center table-flush table-hover bidtbl"
                style="min-height: 125px"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-left">CALL DATE</th>
                    <th scope="col" class="sort text-left">CALL PRICE</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="callSchedule.length == 0">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="data in callSchedule" :key="data.id">
                    <td>{{ data.callDate }}</td>
                    <td>{{ data.callPrice }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>
        </div>
        <div>
          <hr />
          <div class="cursor-pointer">
            <h3
              class="text-left accordion-button"
              v-b-toggle="'accordion-MATERIAL'"
              variant="info"
            >
              Material Events
            </h3>
          </div>
          <b-collapse
            :id="'accordion-MATERIAL'"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="table-responsive">
              <table
                class="table align-items-center table-flush table-hover bidtbl"
                style="min-height: 125px"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-left">EVENT DATE</th>
                    <th scope="col" class="sort text-left">EVENT CODE</th>
                    <th scope="col" class="sort text-left">EVENT TYPE</th>
                    <th scope="col" class="sort text-left">EVENT STATUS</th>
                    <th scope="col" class="sort text-left">CORRECTION DATE</th>
                    <th scope="col" class="sort text-left">MESSAGE</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="materialEvents.length == 0">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="data in materialEvents" :key="data.id">
                    <td>{{ data.eventDate }}</td>
                    <td>{{ data.eventCode }}</td>
                    <td>{{ data.eventType }}</td>
                    <td>{{ data.eventStatus }}</td>
                    <td>{{ data.correctionDate }}</td>
                    <td>{{ data.messageText }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>
        </div>
        <div>
          <hr />
          <div class="cursor-pointer">
            <h3
              class="text-left accordion-button"
              v-b-toggle="'accordion-SINK'"
              variant="info"
            >
              Sink Schedules
            </h3>
          </div>
          <b-collapse
            :id="'accordion-SINK'"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="table-responsive">
              <table
                class="table align-items-center table-flush table-hover bidtbl"
                style="min-height: 125px"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-left">SINK DATE</th>
                    <th scope="col" class="sort text-left">SINK AMOUNT</th>
                    <th scope="col" class="sort text-left">SINK PRICE</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="sinkSchedules.length == 0">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="data in sinkSchedules" :key="data.id">
                    <td>{{ data.sinkDate }}</td>
                    <td>{{ data.sinkAmount }}</td>
                    <td>{{ data.sinkPrice }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>
        </div>
        <div>
          <hr />
          <div class="cursor-pointer">
            <h3
              class="text-left accordion-button"
              v-b-toggle="'accordion-REDEMPTION'"
              variant="info"
            >
              Partial Redemption Data
            </h3>
          </div>
          <b-collapse
            :id="'accordion-REDEMPTION'"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="table-responsive">
              <table
                class="table align-items-center table-flush table-hover bidtbl"
                style="min-height: 125px"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-left">DATE</th>
                    <th scope="col" class="sort text-left">AMOUNT</th>
                    <th scope="col" class="sort text-left">PRICE</th>
                    <th scope="col" class="sort text-left">TYPE</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="partialRedumptionData.length == 0">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="data in partialRedumptionData" :key="data.id">
                    <td>{{ data.partialRedemptionDate }}</td>
                    <td>{{ data.partialRedemptionAmount }}</td>
                    <td>{{ data.partialRedemptionPrice }}</td>
                    <td>{{ data.partialRedemptionType }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-collapse>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import stateConstants from "@/stateConstants";

export default {
  name: "cusipdetail",
  components: {},
  props: ["cusipId", "cusipName","cusipIdcPrice"],
  watch: {
    cusipId: function () {
      this.getCusipDetails();
      this.getOfferList();
      this.idcPrice = this.cusipIdcPrice
    }
  },
  data() {
    return {
      loading: false,
      cusipObj: {},
      isOfferExist: null,
      stateConstants: stateConstants,
      referenceData: {},
      callSchedule: [],
      materialEvents: {},
      sinkSchedules: {},
      sinkDetails: {},
      partialRedumptionData: {},
      defaultDetails : {},
      idcPrice : 0,
      idcApiRunning : false,
      offerInEcn : null,
      offerInEcnArray : [],
      isNoBidCusip : false,
      cusipBidStatusLoader : false
    };
  },
  methods: {
    markAsDoNotBid(){
      if(this.isNoBidCusip){
        this.removeCusipFromList(this.cusipName)
      }else{
        this.addCusipToList(this.cusipName)
      }
    },
    removeCusipFromList(cusip){
        this.cusipBidStatusLoader = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        let data = {"userId":authService.getUser().id,"cusip":cusip}
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/nobid-remove",data,
                auth
            )
            .then(() => {
                this.cusipBidStatusLoader = false; 
                this.getCusipNotBidStatus();
                this.$alert("CUSIP Removed from do not bid list","","success");
            })
            
    },
    addCusipToList(cusip){
        this.cusipBidStatusLoader = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        let data = {"userId":authService.getUser().id,"cusip":cusip}
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/nobid-add",data,
                auth
            )
            .then(() => {
                this.cusipBidStatusLoader = false; 
                this.getCusipNotBidStatus();
                this.$alert("CUSIP Added to do not bid list","","success");
            })
            
    },
    getIdcPrice(){
      this.idcApiRunning = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = { "cusip": this.cusipName, 
                    "fetchAskEval": false,
                    "fetchAmendmentDate":false,
                    "fetchYield":false,
                    "fetchInstMidEval":false,
                    "fetchMidEval":false,
                    "fetchInstBidEval":false,
                    "fetchBidEval":true,
                    "fetchInstAskEval":false,
                    "fetchViaApi" : false,
                    "userId":  authService.getUser().id
                   }
      if(window.location.pathname.includes("/autobidder/supportdata")){
        data.fetchViaApi = true
      }

      this.$http
        .post(
          config.baseUrlAutoBidder +"/rplus/idc-data",data,
          auth
        )
        .then((result) => {
          this.idcApiRunning = false;
          if (result.data) {
            this.idcPrice = result.data.bid.evaluation;
            this.$emit("idcprice",this.idcPrice);

          }
          
        })
    },
    convertToWord(text) {
      const result = text.replace(/([A-Z])/g, " $1");
      let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      finalResult = finalResult.toUpperCase();
      return finalResult;
    },
    getStateName(id) {
      return id ? this.stateConstants.find((x) => x.id === id).short : "N/A";
    },
    getOfferList() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/offer/check-offer-feed-exist?cusip="+this.cusipName,
          auth
        )
        .then((result) => {
          this.offerInEcnArray = result.data;
          this.offerInEcn = result.data[0];
          if(this.offerInEcn){
            if(!this.offerInEcn.createSource.toLowerCase().includes('arbs')) this.offerInEcn.createSource = "IMS";
            this.$emit("offerinecn",this.offerInEcn);
          }
        })
        .catch((e) => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    getCusipDetails() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(config.baseUrlBidSide + "/cusip/" + this.cusipId, auth)
        .then(
          (result) => {
            if (result.data) {
              result.data.coupon = (result.data.coupon * 100).toFixed(3);
              // result.data.stateId = result.data.stateId ? result.data.stateId : '0';
              result.data.product =
                result.data.offeringTypeId == 1 ? "MUNICIPAL" : "CORPORATE";
              result.data.offeringType =
                result.data.offeringTypeId == 1 ? "MUNIS" : "CORPORATES";
              result.data.state = this.getStateName(result.data.stateId);
              delete result.data.id;
              delete result.data.isSecurityMasterExist;
              delete result.data.offeringTypeId;
              delete result.data.stateId;
              delete result.data.status;
              delete result.data.callDate;

              if(result.data.defaultDetails){
                for (const property in result.data.defaultDetails) {
                  //console.log(`${property}: ${object[property]}`);
                  delete result.data[property]
                }
              }
              this.referenceData = result.data.referenceData;
              this.defaultDetails = result.data.defaultDetails;
              this.defaultDetails.coupon = (this.defaultDetails.coupon * 100).toFixed(3);

              if (result.data.referenceData) {
                this.callSchedule = result.data.referenceData.callSchedules;
                this.materialEvents = result.data.referenceData.materialEvents;
                this.sinkDetails = result.data.sinkDetails;
                this.sinkSchedules = result.data.referenceData.sinkSchedules;
                this.partialRedumptionData =
                  result.data.referenceData.partialRedemptions;

                delete this.referenceData.callSchedules;
                delete this.referenceData.materialEvents;
                delete this.referenceData.sinkDetails;
                delete this.referenceData.sinkSchedules;
                delete this.referenceData.partialRedemptions;
              }
              delete result.data.referenceData;
              delete result.data.defaultDetails;
              
            }
            this.loading = false;
            this.cusipObj = result.data;
          },
          () => {
            this.loading = false;
          }
        );
    },
    getCusipNotBidStatus() {
      this.cusipBidStatusLoader = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/check-nobid?userId="+authService.getUser().id+"&cusip="+this.cusipName,
          auth
        )
        .then((result) => {
         this.isNoBidCusip = result.data.isNoBidCusip;
         this.cusipBidStatusLoader = false;
        })
        .catch((e) => {
          console.log("Error", e);
          this.cusipBidStatusLoader = false;
          //self.loading = false;
        });
    },
  },
  mounted() {
    this.getCusipDetails();
    this.getOfferList();
    this.getCusipNotBidStatus();
    //this.getIdcPrice();
    if(this.cusipIdcPrice){
      this.idcPrice = this.cusipIdcPrice
    }
  },
};
</script>
<style scoped>
.cusip-parent {
  display: flex;
  flex-wrap: wrap;
}
.cusip-details {
  padding: 15px;
}
.cusip-child {
  padding: 9px;
  min-width: 130px;
}
.cusip-child span {
  font-size: 15px !important;
  color: #555555 ;
}
.cusip-child h5 {
  color: #333333 ;
}
.accordion-button:after {
  content: "\21E9";
  color: #777;
  font-weight: bold;
  float: right;
  margin-left: 5px;
}
.accordion-button:hover {
  text-decoration: underline;
}
.accordion-button.not-collapsed:after {
  content: "\21E7";
}
</style>
